<template>
    <svg :width="size" :height="size" viewBox="0 0 16 16" fill="none">
        <path
            d="M12.9969 1.3366C13.4063 1.3368 13.8085 1.44472 14.163 1.64953C14.5175 1.85434 14.8119 2.14883 15.0166 2.50342C15.2213 2.85801 15.3291 3.26021 15.3291 3.66964C15.3292 4.07906 15.2215 4.4813 15.0169 4.83594L10.0169 13.4959C9.78619 13.8954 9.44225 14.2176 9.02852 14.4217C8.61479 14.6257 8.14984 14.7026 7.69245 14.6425C7.23505 14.5825 6.80572 14.3882 6.45872 14.0842C6.11172 13.7802 5.86262 13.3801 5.7429 12.9346L4.7429 9.2046L10.5896 5.8286C10.7414 5.73957 10.8519 5.59408 10.8969 5.42388C10.9419 5.25369 10.9178 5.0726 10.8297 4.92014C10.7417 4.76768 10.597 4.65623 10.4271 4.61011C10.2572 4.56398 10.0759 4.58693 9.9229 4.67394L4.0769 8.04927L1.34757 5.31927C1.02125 4.99299 0.799007 4.57727 0.70894 4.12469C0.618872 3.67211 0.665024 3.20298 0.84156 2.77663C1.0181 2.35027 1.31709 1.98584 1.70073 1.7294C2.08437 1.47296 2.53544 1.33604 2.9969 1.33594L12.9969 1.3366Z"
            fill="currentColor" />
    </svg>
</template>

<script>
export default {
  props: {
    size: {
      type: String,
      default: '16px'
    }
  }
}
</script>

<style></style>



// WEBPACK FOOTER //
// send.icon.vue?779ec8be